import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";

import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import { AppContext } from "App";
import { FinancialIcon } from "components/Icons/Icons";
import { MODULE_FINANCIAL } from "components/Menu/config/constants";
import { useSnackbar } from "notistack";

import { TilleyCard } from "../../Cards/TilleyCard";
import { getBalanceSheetFromFinancialStatementScheduleAccounts } from "../FinancialHelpers";
import { hydrateBalanceSheetDocumentDictionaries } from "../FinancialService";
import { BalanceSheetReportTable } from "../forms/BalanceSheetReportTable";
import useFinanceReport from "../useFinanceReport";
import {
  FILTER_TERMS_ASSETS_CURRENT_SCHEDULES,
  FILTER_TERMS_ASSETS_INTERMEDIATE_SCHEDULES,
  FILTER_TERMS_ASSETS_LONGTERM_SCHEDULES,
  FILTER_TERMS_LIABILITIES_CURRENT_SCHEDULES,
  FILTER_TERMS_LIABILITIES_INTERMEDIATE_SCHEDULES,
  FILTER_TERMS_LIABILITIES_LONGTERM_SCHEDULES,
  SCHEDULE_FINANCIAL_CATEGORIES,
} from "./useFinancialStatementSchedule";

export const FinancialStatementSchedule_Confirmation = ({ accounts }) => {
  const { globalState } = useContext(AppContext);
  const { producer_token, year } = useParams();

  const { enqueueSnackbar } = useSnackbar();

  const [currentYear, setCurrentYear] = useState(year || globalState?.crop_year);

  const handleError = (err) => {
    console.warn(err);
    enqueueSnackbar(err.detail || err.message || err, { preventDuplicate: true, variant: "error" });
  };

  // ---

  const [selectedCategoryTermsClass, setSelectedCategoryTermsClass] = useState(null);
  const handleCategorySelected = (category) => {
    setSelectedCategoryTermsClass(category);
  };

  const [filteredCategories, setFilteredCategories] = useState([]);
  const [filteredAccounts, setFilteredAccounts] = useState(accounts || []);
  useEffect(() => {
    if (selectedCategoryTermsClass) {
      let _FILTER_MASTER_LIST = [];
      if (selectedCategoryTermsClass === "FILTER_TERMS_ASSETS_CURRENT_SCHEDULES") {
        _FILTER_MASTER_LIST = FILTER_TERMS_ASSETS_CURRENT_SCHEDULES;
      } else if (selectedCategoryTermsClass === "FILTER_TERMS_LIABILITIES_CURRENT_SCHEDULES") {
        _FILTER_MASTER_LIST = FILTER_TERMS_LIABILITIES_CURRENT_SCHEDULES;
      } else if (selectedCategoryTermsClass === "FILTER_TERMS_ASSETS_INTERMEDIATE_SCHEDULES") {
        _FILTER_MASTER_LIST = FILTER_TERMS_ASSETS_INTERMEDIATE_SCHEDULES;
      } else if (selectedCategoryTermsClass === "FILTER_TERMS_LIABILITIES_INTERMEDIATE_SCHEDULES") {
        _FILTER_MASTER_LIST = FILTER_TERMS_LIABILITIES_INTERMEDIATE_SCHEDULES;
      } else if (selectedCategoryTermsClass === "FILTER_TERMS_ASSETS_LONGTERM_SCHEDULES") {
        _FILTER_MASTER_LIST = FILTER_TERMS_ASSETS_LONGTERM_SCHEDULES;
      } else if (selectedCategoryTermsClass === "FILTER_TERMS_LIABILITIES_LONGTERM_SCHEDULES") {
        _FILTER_MASTER_LIST = FILTER_TERMS_LIABILITIES_LONGTERM_SCHEDULES;
      }

      setFilteredCategories(_FILTER_MASTER_LIST);

      const _filteredAccounts = accounts.filter((account) => _FILTER_MASTER_LIST.includes(account?.category));
      setFilteredAccounts(_filteredAccounts);
    } else {
      setFilteredAccounts(accounts);
    }
  }, [accounts, selectedCategoryTermsClass]);

  // ---

  const {
    isLoadingBalanceSheet,

    isLoadingDebtRatios,
    debtRatios,

    isLoadingRatios,
    ratios,
  } = useFinanceReport({
    onError: handleError,
    currentYear,
    loadModules: [MODULE_FINANCIAL],

    producerState: producer_token ? { ...globalState, producer_token } : null,
  });

  // ---

  const [financialStatementScheduleBalanceSheet, setFinancialStatementScheduleBalanceSheet] = useState([]);
  useEffect(() => {
    if (accounts?.length) {
      const _documentDictionary = getBalanceSheetFromFinancialStatementScheduleAccounts(accounts);
      const _balanceSheet = hydrateBalanceSheetDocumentDictionaries(_documentDictionary);
      setFinancialStatementScheduleBalanceSheet(_balanceSheet);
    }
  }, [accounts]);

  // --- --- ---

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <BalanceSheetReportTable
            balanceSheet={financialStatementScheduleBalanceSheet}
            isLoadingBalanceSheet={isLoadingBalanceSheet}
            debtRatios={debtRatios}
            isLoadingDebtRatios={isLoadingDebtRatios}
            ratios={ratios}
            isLoadingRatios={isLoadingRatios}
            onCategorySelected={handleCategorySelected}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          {SCHEDULE_FINANCIAL_CATEGORIES.filter(
            (category) => !selectedCategoryTermsClass || filteredCategories?.includes(category)
          ).map((category, index) => (
            <Stack direction="column" spacing={1} key={index}>
              <Box>
                <Typography variant="h5" sx={{ textTransform: "capitalize" }}>
                  {category
                    .replace("schedule_financial_statement_accounts_", "")
                    ?.replace("schedule_financial_statement_", "")
                    ?.replace("_", " ")}{" "}
                  Accounts
                </Typography>
              </Box>
              <Box className="cardContainer" sx={{ mb: 1 }}>
                {filteredAccounts
                  ?.filter((item) => item?.category === category)
                  ?.map((item, cardIndex) => (
                    <TilleyCard
                      key={cardIndex}
                      Avatar={FinancialIcon}
                      title={item?.account_name || item?.name}
                      subtitle={item?.financial_institution_name + " (" + item?.account_type + ")"}
                    />
                  ))}
              </Box>
              <Divider />
            </Stack>
          ))}
        </Grid>
      </Grid>

      <Divider />
    </>
  );
};
